import { baseApi } from '@/shared';
import { transactionsAdapter } from '../utils/helpers/adapter';

import type { TGetTransactions, TTransactionResponse } from './types';

export const transactionsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getTransactons: build.query<TTransactionResponse, TGetTransactions>({
      query: (params: TGetTransactions) => ({
        url: '/admin/transactions/list',
        params: {
          id: params.id,
          currency: params.currency,
          shop_id: params.shopId,
          type: params.type,
          status: params.status,
          created_from: params.createdFrom,
          created_to: params.createdTo,
          amount_from: params.amountFrom,
          amount_to: params.amountTo,
          payment_id: params.paymentId,
          page_size: params.pageSize,
          page: params.page,
          ascending: params.ascending,
        },
      }),
      transformResponse: transactionsAdapter,
      // providesTags: [],
    }),

  }),
});

export const {
  useGetTransactonsQuery,
} = transactionsApi;
